import { render, staticRenderFns } from "./ModalEditarComision.vue?vue&type=template&id=2fdf52e6&scoped=true&"
import script from "./ModalEditarComision.vue?vue&type=script&lang=js&"
export * from "./ModalEditarComision.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarComision.vue?vue&type=style&index=0&id=2fdf52e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf52e6",
  null
  
)

export default component.exports